import { render, staticRenderFns } from "./CrewDashboardCard.vue?vue&type=template&id=ab9e5a38&scoped=true&"
import script from "./CrewDashboardCard.vue?vue&type=script&lang=ts&"
export * from "./CrewDashboardCard.vue?vue&type=script&lang=ts&"
import style0 from "./CrewDashboardCard.vue?vue&type=style&index=0&id=ab9e5a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9e5a38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
